'use strict';

var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var MODES = ['info', 'success', 'danger', 'warning'];
var BASE_CSS_CLASS = 'ds-organisms-alert';

var Alert = function Alert(_ref) {
  var children = _ref.children,
      className = _ref.className,
      action = _ref.action,
      mode = _ref.mode,
      onSelect = _ref.onSelect;
  var cssClassName = React.useMemo(function () {
    return "".concat(BASE_CSS_CLASS, " ").concat(BASE_CSS_CLASS, "--").concat(mode, " ").concat(className);
  }, [mode, className]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: cssClassName
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-organisms-alert__content"
  }, children), action != null && /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "ds-organisms-alert__action",
    onClick: onSelect
  }, action));
};

Alert.propTypes = {
  children: PropTypes__default['default'].node.isRequired,
  className: PropTypes__default['default'].string,
  action: PropTypes__default['default'].node,
  mode: PropTypes__default['default'].oneOf(MODES),
  onSelect: PropTypes__default['default'].func
};
Alert.defaultProps = {
  className: '',
  action: null,
  mode: 'info',
  onSelect: function onSelect() {}
};

module.exports = Alert;
